<template>
  <div class="page-journal">
    <n-card :loading="$var('load')">
      <n-tabs :data="tabs" state />
      <n-tabs-content v-if="project" class="content">
        <template #chapter1>
          <chapter1 :project="project" :journal="journal" :editable="editable" />
        </template>
        <template #chapter2>
          <chapter2 :project="project" :journal="journal" />
        </template>
      </n-tabs-content>
    </n-card>
  </div>
</template>

<script>
import Chapter1 from './Chapter1'
import Chapter2 from './Chapter2'

export default {
  name: 'PageJournal',
  components: { Chapter1, Chapter2, },
  props: {
    project: { type: Object, default: null, },
    journal: { type: Object, default: null, },
    data: { type: Object, default: () => ({}), },
    loading: { type: Boolean, default: false, },
    editable: { type: Boolean, default: false, },
  },
  data: () => ({
    activeTab: 'chapter1',
    tabs: [
      { name: 'chapter1', title: 'Общие сведения', },
      { name: 'chapter2', title: 'Записи', },
    ],
  }),
}
</script>

<style lang="scss" scoped>
  .page-journal {
    &::v-deep {
      .chapter-title {
        font-size: 1.5em;
        text-align: center;
        margin: 30px auto 55px;
        max-width: 800px;
        font-weight: 300;
        line-height: 1.3;
      }
      .chapter-info {
        font-size: .9em;
        ul {
          list-style: decimal;
        }
        li {
          margin: 10px;
        }
      }
      .n-table {
        font-size: .9em;
      }
    }
    .content {
      padding: 20px 0 0;
      position: relative;
    }
  }
</style>
